import FormBase from "../FormBase";
import FormFieldAttachmentBase from "../../forms/FormFieldAttachmentBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";

export enum EAttachmentMultiprofissional {
    AtestadoCapacidadeFisicaCognitiva = 15,
    CartaReferencia = 16,
    CarteiraVacionacaoTermoRecusa = 17,
    ComprovantePagamentoAnuidadeConselhoProfissional = 18,
    CopiaCarteiraConselho = 19,
    CopiaDiplomaGraduacaoProfissional = 20,
    CopiaRGCPF = 21,
    CopiaTituloEspecialista = 22,
    CopiaResidenciaMedica = 23,
    CurriculoResumidoAtualizado = 24,
    DeclaracaoConflito = 25,
    FotoFundoBranco = 26,
    ComprovanteVacinaCovid = 58

}

export default class AttachmentForm implements FormBase {

    AtestadoCapacidadeFisicaCognitiva: FormFieldAttachmentBase;
    CartaReferencia: FormFieldAttachmentBase;
    CarteiraVacionacaoTermoRecusa: FormFieldAttachmentBase;
    ComprovantePagamentoAnuidadeConselhoProfissional: FormFieldAttachmentBase;
    CopiaCarteiraConselho: FormFieldAttachmentBase;
    CopiaDiplomaGraduacaoProfissional: FormFieldAttachmentBase;
    CopiaRGCPF: FormFieldAttachmentBase;
    CopiaTituloEspecialista: FormFieldAttachmentBase;
    CopiaResidenciaMedica: FormFieldAttachmentBase;
    CurriculoResumidoAtualizado: FormFieldAttachmentBase;
    DeclaracaoConflito: FormFieldAttachmentBase;
    FotoFundoBranco: FormFieldAttachmentBase;
    ComprovanteVacinaCovid: FormFieldAttachmentBase;


    constructor() {
        this.AtestadoCapacidadeFisicaCognitiva = new FormFieldAttachmentBase([], 2, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.AtestadoCapacidadeFisicaCognitiva);
        this.CartaReferencia = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.CartaReferencia);
        this.CarteiraVacionacaoTermoRecusa = new FormFieldAttachmentBase([], 1, [], EAttachmentMultiprofissional.CarteiraVacionacaoTermoRecusa);
        this.ComprovantePagamentoAnuidadeConselhoProfissional = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.ComprovantePagamentoAnuidadeConselhoProfissional);
        this.CopiaCarteiraConselho = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.CopiaCarteiraConselho);
        this.CopiaDiplomaGraduacaoProfissional = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.CopiaDiplomaGraduacaoProfissional);
        this.CopiaRGCPF = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.CopiaRGCPF);
        this.CopiaTituloEspecialista = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentMultiprofissional.CopiaTituloEspecialista, ((value: any) => { return this.ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value) }));
        this.CopiaResidenciaMedica = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.CUSTOM)], EAttachmentMultiprofissional.CopiaResidenciaMedica, ((value: any) => { return this.ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value) }));
        this.CurriculoResumidoAtualizado = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.CurriculoResumidoAtualizado);
        this.DeclaracaoConflito = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.DeclaracaoConflito);
        this.FotoFundoBranco = new FormFieldAttachmentBase([], 1, [new ValidationBase("", ValidationType.ANEXO_OBRIGATORIO)], EAttachmentMultiprofissional.FotoFundoBranco);
        this.ComprovanteVacinaCovid = new FormFieldAttachmentBase([], 1, [], EAttachmentMultiprofissional.ComprovanteVacinaCovid);
    }

    ValidateFieldCustomCopiaTituloEspecialistaCopiaResidenciaMedica(value: any): string {
        if (this.CopiaTituloEspecialista.Values.length === 0 && this.CopiaResidenciaMedica.Values.length === 0) {
            return "Por favor, insira a Cópia do Titulo de Especialista ou Residência Médica."
        } else {
            this.CopiaTituloEspecialista.Error = "";
            this.CopiaResidenciaMedica.Error = "";
            return "";
        }
    }

    static NewInstance(): AttachmentForm {
        return new AttachmentForm();
    }

    CallInsertOrUpdateApi(): Promise<boolean> {
        return Promise.resolve(true);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;
        let maxLengthIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];

            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }

            if (element !== null) {

                let files = this.GetFieldByName(element).Values;

                for (let indexFile = 0; indexFile < files.length; indexFile++) {
                    const file = files[indexFile];

                    if (file.ErrorMessage !== null && file.ErrorMessage !== "") {
                        formIsValid = false;
                        maxLengthIsValid = false;
                    }
                }
            }
        }

        if (!formIsValid) {
            if (!maxLengthIsValid) {
                return "O tamanho do arquivo é maior do que o permitido, impossibilitando avançar. Favor remover e inserir arquivo do tamanho de até 3MB."
            } else {
                return "Por favor, insira os anexos obrigatórios."
            }
        } else {
            return "";
        }
    }


    GetFieldByName(name: string): FormFieldAttachmentBase {
        switch (name) {

            case "AtestadoCapacidadeFisicaCognitiva":
                return this.AtestadoCapacidadeFisicaCognitiva

            case "CartaReferencia":
                return this.CartaReferencia

            case "CarteiraVacionacaoTermoRecusa":
                return this.CarteiraVacionacaoTermoRecusa

            case "ComprovantePagamentoAnuidadeConselhoProfissional":
                return this.ComprovantePagamentoAnuidadeConselhoProfissional

            case "CopiaCarteiraConselho":
                return this.CopiaCarteiraConselho

            case "CopiaDiplomaGraduacaoProfissional":
                return this.CopiaDiplomaGraduacaoProfissional

            case "CopiaRGCPF":
                return this.CopiaRGCPF

            case "CopiaTituloEspecialista":
                return this.CopiaTituloEspecialista

            case "CopiaResidenciaMedica":
                return this.CopiaResidenciaMedica

            case "CurriculoResumidoAtualizado":
                return this.CurriculoResumidoAtualizado

            case "DeclaracaoConflito":
                return this.DeclaracaoConflito

            case "FotoFundoBranco":
                return this.FotoFundoBranco

            case "ComprovanteVacinaCovid":
                return this.ComprovanteVacinaCovid

            default:
                return new FormFieldAttachmentBase([], 0, []);
        }
    }
};
